import { Button } from '@/shared';
import {
  useStripeConnectMutation,
  useStripeConnectStatus,
} from '@/features/payments/hooks';
import { formattedDate } from '@/shared/utils/formatDate';

export const StripeConnectionSetup = () => {
  const { mutate, isPending } = useStripeConnectMutation();
  const { data: statusData, isLoading: isStatusLoading } =
    useStripeConnectStatus();

  const isConnected = statusData?.data?.status === 'SYNCED';
  const statusMessage = isConnected
    ? 'Connected'
    : statusData?.data?.status || 'Not connected';
  const statusColor = isConnected ? 'text-green-600' : 'text-[#891518]';

  const handleConnect = () => {
    mutate(undefined, {
      onSuccess: (response) => {
        if (response.data?.url) {
          window.location.href = response.data.url;
        }
      },
      onError: (error: any) => {
        console.error('Stripe connect error:', error);
      },
    });
  };

  console.log('statusData', statusData);
  const lastSyncedDate = statusData?.data?.date
    ? formattedDate(statusData.data.date)
    : 'Never';

  return (
    <div className="p-4 rounded-lg border-gray-300 border shadow-lg md:shadow-none ">
      <div className="w-full flex flex-col md:flex-row gap-4 items-center justify-center md:justify-between">
        <div className="flex items-center gap-6">
          <img src="/assets/icons/stripe.svg" alt="Stripe" />
          <div>
            <p className="text-base md:text-2xl text-text-primary font-bold">
              {isConnected ? 'Stripe Status' : 'Setup pending'}
            </p>
            <p className={`text-base md:text-xl ${statusColor}`}>
              {isStatusLoading ? 'Loading...' : statusMessage}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4 md:gap-8">
          <p className="text-base md:text-xl text-text-secondary">
            Last Synced: {isStatusLoading ? '...' : lastSyncedDate}
          </p>
          <Button
            className="!text-base md:text-lg !font-bold px-6 py-3"
            onClick={handleConnect}
            disabled={isPending || isConnected}
          >
            {isPending ? 'Connecting...' : 'Connect stripe account'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectionSetup;
